import React, { memo } from 'react';
import { FormHTMLInline } from '@core/components/form';
import { FormControl } from '@core/utils/form';
import { GlossaryService } from '@business/services/glossary_service';

export interface ParagraphProps extends React.HTMLProps<HTMLDivElement> {
  control: FormControl<string>;
  editable?: boolean;
}

export const Paragraph = memo((props: ParagraphProps) => {
  const { control, editable, ...rest } = props;
  return (
    <div {...rest}>
      {!!editable && <FormHTMLInline control={control} multipleLines readonly={!editable} />}
      {!editable && GlossaryService.getGlossaryContent(control.value || '<div></div>')}
    </div>
  );
});
